module.exports = __webpack_public_path__ + "img/1.f5c049a0.jpg";